import { AminoMsg } from "../../amino";
import { AminoConverters } from "../../amino/types";
import { MsgGrant, MsgRevoke } from "../../types/cosmos/authz/v1beta1/tx";

export interface AminoMsgGrant extends AminoMsg {
  readonly type: "cosmos-sdk/MsgGrant";
  readonly value: {
    readonly granter: string;
    readonly grantee: string;
    readonly grant: {
      readonly authorization: {
        readonly type_url: string;
        readonly value: Uint8Array;
      };
      readonly expiration?: {
        readonly seconds: string;
        readonly nanos: number;
      };
    };
  };
}

export function isAminoMsgGrant(msg: AminoMsg): msg is AminoMsgGrant {
  return msg.type === "cosmos-sdk/MsgGrant";
}

export interface AminoMsgRevoke extends AminoMsg {
  readonly type: "cosmos-sdk/MsgRevoke";
  readonly value: {
    readonly granter: string;
    readonly grantee: string;
    readonly msg_type_url: string;
  };
}

export function isAminoMsgRevoke(msg: AminoMsg): msg is AminoMsgRevoke {
  return msg.type === "cosmos-sdk/MsgRevoke";
}

export function createAuthzAminoConverters(): AminoConverters {
  return {
    "/cosmos.authz.v1beta1.MsgGrant": {
      aminoType: "cosmos-sdk/MsgGrant",
      toAmino: ({
        granter,
        grantee,
        grant,
      }: MsgGrant): AminoMsgGrant["value"] => ({
        granter,
        grantee,
        grant: {
          authorization: {
            type_url: grant?.authorization?.typeUrl || "",
            value: grant?.authorization?.value || new Uint8Array(),
          },
          expiration: grant?.expiration
            ? {
                seconds: grant.expiration.seconds.toString(),
                nanos: grant.expiration.nanos,
              }
            : undefined,
        },
      }),
      fromAmino: ({
        granter,
        grantee,
        grant,
      }: AminoMsgGrant["value"]): MsgGrant => ({
        granter,
        grantee,
        grant: {
          authorization: {
            typeUrl: grant.authorization.type_url,
            value: grant.authorization.value,
          },
          expiration: grant.expiration
            ? {
                seconds: BigInt(grant.expiration.seconds),
                nanos: grant.expiration.nanos,
              }
            : undefined,
        },
      }),
    },
    "/cosmos.authz.v1beta1.MsgRevoke": {
      aminoType: "cosmos-sdk/MsgRevoke",
      toAmino: ({
        granter,
        grantee,
        msgTypeUrl,
      }: MsgRevoke): AminoMsgRevoke["value"] => ({
        granter,
        grantee,
        msg_type_url: msgTypeUrl,
      }),
      fromAmino: ({
        granter,
        grantee,
        msg_type_url,
      }: AminoMsgRevoke["value"]): MsgRevoke => ({
        granter,
        grantee,
        msgTypeUrl: msg_type_url,
      }),
    },
  };
}

